import { render } from "./PersonaProfile.vue?vue&type=template&id=0c62dd4e"
import script from "./PersonaProfile.vue?vue&type=script&lang=js"
export * from "./PersonaProfile.vue?vue&type=script&lang=js"

import exportComponent from "/Users/mathieu/www-root/persona-tool/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__